import React from "react";

interface HealthStatusBadgeProps {
  healthStatus?: string; // can be undefined or empty
}

export const HealthStatusBadge: React.FC<HealthStatusBadgeProps> = ({
  healthStatus,
}) => {
  const normalized = healthStatus?.toLowerCase().trim() || "";

  // Define styles for each status
  const styles = {
    good: "text-green-600 bg-green-100 border-green-600",
    warning: "text-yellow-600 bg-yellow-100 border-yellow-600",
    bad: "text-red-600 bg-red-100 border-red-600",
  };

  // Pick style based on the normalized status
  let colorClass = "";
  let label = "";

  if (normalized === "good") {
    colorClass = styles.good;
    label = "Good";
  } else if (
    normalized === "warning" ||
    normalized === "warn" ||
    normalized === "caution"
  ) {
    colorClass = styles.warning;
    label = "Warning";
  } else if (normalized === "bad" || normalized === "poor") {
    colorClass = styles.bad;
    label = "Bad";
  } else {
    // Default fallback
    colorClass = "text-gray-600 bg-gray-100 border-gray-400";
    label = "Unknown";
  }

  return (
    <h1
      className={`font-semibold ${colorClass} border rounded-full px-3 py-0 text-sm w-fit`}
    >
      {label}
    </h1>
  );
};

interface ActiveStatusBadgeProps {
  isActive?: boolean;
}

export const ActiveStatusBadge: React.FC<ActiveStatusBadgeProps> = ({
  isActive,
}) => {
  const status = isActive ? "Active" : "Inactive";

  const colorClass = isActive
    ? "text-green-600 bg-green-100 border-green-600"
    : "text-red-600 bg-red-100 border-red-600";

  return (
    <h1
      className={`font-semibold ${colorClass} border rounded-full px-2 py-0 text-[13px] w-fit`}
    >
      {status}
    </h1>
  );
};

interface CurrentLocationProps {
  location?: string;
}

export const CurrentLocation: React.FC<CurrentLocationProps> = ({
  location,
}) => {
  const colorClass =
    location === "InTransit"
      ? "text-green-600 bg-green-100 border-green-600"
      : "text-gray-600 bg-gray-100 border-gray-600";

  const label = location === "InTransit" ? "In Transit" : "Offline";

  return (
    <h1
      className={`font-semibold ${colorClass} border rounded-full px-3 py-0 text-[13px] w-fit`}
    >
      {label}
    </h1>
  );
};
